import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "relative w-64 h-screen py-6 overflow-auto bg-white border-r border-gray-200 scrollbar-style" }
const _hoisted_2 = { class: "px-8 py-4 mb-6" }
const _hoisted_3 = { class: "flex items-center justify-between min-w-0 space-x-3" }
const _hoisted_4 = { class: "flex flex-col flex-1 min-w-0" }
const _hoisted_5 = { class: "text-sm truncate text-primary-500" }
const _hoisted_6 = { class: "mt-3" }
const _hoisted_7 = {
  class: "space-y-4",
  role: "group",
  "aria-labelledby": "desktop-main-headline"
}
const _hoisted_8 = { key: 0 }
const _hoisted_9 = ["href", "aria-current"]
const _hoisted_10 = ["src"]
const _hoisted_11 = {
  key: 0,
  class: "inline-block w-1 h-6 rounded-tr rounded-br bg-primary-500 mr-7"
}
const _hoisted_12 = ["src"]
const _hoisted_13 = { class: "flex-1 text-sm" }
const _hoisted_14 = ["href", "aria-current"]
const _hoisted_15 = {
  key: 0,
  class: "inline-block w-1 h-6 rounded-tr rounded-br bg-primary-500 mr-7"
}
const _hoisted_16 = ["src"]

import { computed } from 'vue';
import { useRouter } from 'vue-router';
import {
    Disclosure,
    DisclosureButton,
    DisclosurePanel,
} from "@headlessui/vue";
import AdminData from '@/classes/AdminData';
import { useNetworkStore } from '@/store/network';

interface generalNavType {
    name: string,
    href: string,
    parentUrl: Array<string> | string,
    icon: any,
    activeIcon: any,
    allowed?: boolean
    children?: generalNavType[]
}

// console.log(window.$hasPermission());


export default /*@__PURE__*/_defineComponent({
  __name: 'SidebarMenu',
  setup(__props) {

const router = useRouter();
const networkStore = useNetworkStore();

const currentRoutePath = router.currentRoute.value.path;
const getLoggedAdmin = computed(() => AdminData.getAdmin());
const isNetworkAvailable = computed(() => networkStore.isNetworkAvailable);

const navigation: generalNavType[] = computed(() => [
    {
        name: "Dashboard",
        href: "/home",
        parentUrl: [
            "/home",
        ],
        icon: "/assets/icons/nav/ic-nav-dashboard.svg",
        activeIcon: "/assets/icons/nav/ic-nav-dashboard-active.svg",
        allowed:
            isNetworkAvailable.value &&
            window.$hasPermission('view-dashboard')
    },
    {
        name: "Branches",
        href: "/branches",
        parentUrl: [
            "/branches",
        ],
        icon: "/assets/icons/nav/ic-nav-branches.svg",
        activeIcon: "/assets/icons/nav/ic-nav-branches-active.svg",
        allowed:
            !isNetworkAvailable.value ||
            (window.$hasPermission('create-branch') ||
            window.$hasPermission('view-branch') ||
            window.$hasPermission('update-branch') ||
            window.$hasPermission('archive-branch') ||
            window.$hasPermission('restore-branch') ||
            window.$hasPermission('create-blocked-date') ||
            window.$hasPermission('update-blocked-date') ||
            window.$hasPermission('archive-blocked-date') ||
            window.$hasPermission('restore-blocked-date') ||
            window.$hasPermission('set-clinic-hours') ||
            window.$hasPermission('update-clinic-hours') ||
            window.$hasPermission('create-company') ||
            window.$hasPermission('update-company') ||
            window.$hasPermission('archive-company') ||
            window.$hasPermission('restore-company') ||
            window.$hasPermission('view-company') ||
            window.$hasPermission('soft-book-dates-for-individual-patient') ||
            window.$hasPermission('set-booking-time-intervals'))
    },
    {
        name: "Vouchers",
        href: "/vouchers",
        parentUrl: [
            "/vouchers",
        ],
        icon: "/assets/icons/nav/ic-nav-voucher.svg",
        activeIcon: "/assets/icons/nav/ic-nav-voucher-active.svg",
        allowed:
                isNetworkAvailable.value &&
                (window.$hasPermission('create-vouchers') ||
                window.$hasPermission('view-vouchers') )
    },
    {
        name: "Contents",
        href: "#",
        parentUrl: ["#"],
        icon: "/assets/icons/nav/ic-nav-contents.svg",
        activeIcon: "/assets/icons/nav/ic-nav-contents-active.svg",
        children: [
            {
                name: "Packages",
                href: '/contents/packages',
                parentUrl: "/contents/packages",
                icon: "/assets/icons/nav/ic-nav-bullet.svg",
                activeIcon: "/assets/icons/nav/ic-nav-bullet-active.svg",
                allowed:
                    isNetworkAvailable.value &&
                    (window.$hasPermission('view-packages') ||
                    window.$hasPermission('upload-pdf-file') || 
                    window.$hasPermission('update-package-and-rider-schedule'))
            },
            {
                name: "Riders",
                href: '/contents/riders',
                parentUrl: "/contents/riders",
                icon: "/assets/icons/nav/ic-nav-bullet.svg",
                activeIcon: "/assets/icons/nav/ic-nav-bullet-active.svg",
                allowed:
                    isNetworkAvailable.value &&
                    (window.$hasPermission('create-content') ||
                    window.$hasPermission('update-content') ||
                    window.$hasPermission('archive-content') ||
                    window.$hasPermission('restore-content') ||
                    window.$hasPermission('update-package-and-rider-schedule'))
            },
            {
                name: "Illness/Conditions",
                href: '/contents/conditions',
                parentUrl: "/contents/conditions",
                icon: "/assets/icons/nav/ic-nav-bullet.svg",
                activeIcon: "/assets/icons/nav/ic-nav-bullet-active.svg",
                allowed:
                    isNetworkAvailable.value &&
                    (window.$hasPermission('create-content') ||
                    window.$hasPermission('update-content') ||
                    window.$hasPermission('archive-content') ||
                    window.$hasPermission('restore-content'))
            },
            {
                name: "HMO Accreditations",
                href: '/contents/hmo-accreditation',
                parentUrl: "/contents/hmo-accreditation",
                icon: "/assets/icons/nav/ic-nav-bullet.svg",
                activeIcon: "/assets/icons/nav/ic-nav-bullet-active.svg",
                allowed:
                    isNetworkAvailable.value &&
                    window.$hasPermission('update-content')
            },
            {
                name: "Email Notifications",
                href: '/contents/email-notification',
                parentUrl: "/contents/email-notification",
                icon: "/assets/icons/nav/ic-nav-bullet.svg",
                activeIcon: "/assets/icons/nav/ic-nav-bullet-active.svg",
                allowed:
                    isNetworkAvailable.value &&
                    window.$hasPermission('update-content')
            },
            {
                name: "System Notifications",
                href: '/contents/system-notification',
                parentUrl: "/contents/system-notification",
                icon: "/assets/icons/nav/ic-nav-bullet.svg",
                activeIcon: "/assets/icons/nav/ic-nav-bullet-active.svg",
                allowed:
                    isNetworkAvailable.value &&
                    window.$hasPermission('update-content')
            },
            {
                name: "Pages",
                href: '/contents/pages/index',
                parentUrl: "/contents/pages/index",
                icon: "/assets/icons/nav/ic-nav-bullet.svg",
                activeIcon: "/assets/icons/nav/ic-nav-bullet-active.svg",
                allowed:
                    isNetworkAvailable.value &&
                    (window.$hasPermission('view-homepage-setup') ||
                    window.$hasPermission('update-homepage-contents'))
            },
        ],
    },
    {
        name: "Accounts",
        href: "#",
        parentUrl: [
           "#"
        ],
        icon: "/assets/icons/nav/ic-nav-accounts.svg",
        activeIcon: "/assets/icons/nav/ic-nav-accounts-active.svg",
        children: [
            {
                name: "Patients",
                href: '/accounts/patients',
                parentUrl: "/accounts/patients",
                icon: "/assets/icons/nav/ic-nav-bullet.svg",
                activeIcon: "/assets/icons/nav/ic-nav-bullet-active.svg",
                allowed:
                    !isNetworkAvailable.value ||
                    (window.$hasPermission('view-individual-patients') ||
                    window.$hasPermission('view-corporate-patients') ||
                    window.$hasPermission('add-medical-notes-and-results') ||
                    window.$hasPermission('view-corporate-patient-medical-records') ||
                    window.$hasPermission('view-web-booking-medical-records') ||
                    window.$hasPermission('view-contact-center-booking-medical-records') ||
                    window.$hasPermission('view-patient-medical-records') ||
                    window.$hasPermission('view-medical-records-in-offline'))
            },
            {
                name: "Admins",
                href: '/accounts/admins',
                parentUrl: "/accounts/admins",
                icon: "/assets/icons/nav/ic-nav-bullet.svg",
                activeIcon: "/assets/icons/nav/ic-nav-bullet-active.svg",
                allowed:
                    isNetworkAvailable.value &&
                    (window.$hasPermission('create-admin-account') ||
                    window.$hasPermission('update-admin-account') ||
                    window.$hasPermission('archive-admin-account') ||
                    window.$hasPermission('restore-admin-account') ||
                    window.$hasPermission('register-for-an-account'))
            },
            {
                name: "Roles",
                href: '/accounts/roles',
                parentUrl: "/accounts/roles",
                icon: "/assets/icons/nav/ic-nav-bullet.svg",
                activeIcon: "/assets/icons/nav/ic-nav-bullet-active.svg",
                allowed:
                    isNetworkAvailable.value &&
                    window.$hasPermission('view-role')
            },
        ],
    },
    {
        name: "Reports",
        href: "/reports",
        parentUrl: [
            "/reports",
        ],
        icon: "/assets/icons/nav/ic-nav-reports.svg",
        activeIcon: "/assets/icons/nav/ic-nav-reports-active.svg",
        allowed:
            isNetworkAvailable.value &&
            (
                window.$hasPermission('view-reports') ||
                window.$hasPermission('export-reports') ||
                window.$hasPermission('view-new-member-reports') ||
                window.$hasPermission('view-active-member-reports') ||
                window.$hasPermission('view-total-members') ||
                window.$hasPermission('view-number-of-bookings') ||
                window.$hasPermission('view-individual-patient-bookings') ||
                window.$hasPermission('view-corporate-patient-bookings') 
            )
    },
    {
        name: "Settings",
        href: "/settings",
        parentUrl: [
            "/settings",
        ],
        icon: "/assets/icons/nav/ic-nav-settings.svg",
        activeIcon: "/assets/icons/nav/ic-nav-settings-active.svg",
        allowed:
            isNetworkAvailable.value &&
            window.$hasPermission('manage-settings')
    },
    {
        name: "Activity Logs",
        href: "/activity-logs",
        parentUrl: [
            "/activity-logs",
        ],
        icon: "/assets/icons/nav/ic-nav-activity-logs.svg",
        activeIcon: "/assets/icons/nav/ic-nav-activity-logs-active.svg",
        allowed:
            isNetworkAvailable.value &&
            window.$hasPermission('view-activity-logs')
    },
]);




return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("p", _hoisted_5, _toDisplayString(getLoggedAdmin.value.name), 1),
          _cache[0] || (_cache[0] = _createElementVNode("p", { class: "text-sm text-gray-500 truncate" }, "Admin", -1))
        ])
      ])
    ]),
    _createElementVNode("nav", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(navigation.value, (item) => {
          return (_openBlock(), _createElementBlock(_Fragment, {
            key: item.name
          }, [
            (!item.children)
              ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                  (item.allowed)
                    ? (_openBlock(), _createElementBlock("a", {
                        key: 0,
                        href: item.href,
                        class: _normalizeClass([
                                _unref(currentRoutePath) == item.parentUrl
                                ? 'text-primary-500 pl-0'
                                : 'text-gray-500 hover:text-black',
                                'group flex items-center py-2 text-sm font-medium rounded-md',
                            ]),
                        "aria-current": item.current ? 'page' : undefined
                      }, [
                        _createElementVNode("span", {
                          class: _normalizeClass(["inline-block w-1 h-6 rounded-tr rounded-br mr-7", _unref(currentRoutePath) == item.parentUrl ? 'bg-primary-500' : ''])
                        }, null, 2),
                        _createElementVNode("img", {
                          src: _unref(currentRoutePath) == item.parentUrl ? item.activeIcon : item.icon,
                          class: _normalizeClass([
                                    _unref(currentRoutePath) == item.parentUrl
                                    ? 'text-gray-500'
                                    : 'text-gray-400 group-hover:text-gray-500',
                                    'mr-5 flex-shrink-0 h-5 w-5',
                                ])
                        }, null, 10, _hoisted_10),
                        _createTextVNode(" " + _toDisplayString(item.name), 1)
                      ], 10, _hoisted_9))
                    : _createCommentVNode("", true)
                ]))
              : (
                            item.children &&
                            item.children.filter((e) => e.allowed).length > 0
                        )
                ? (_openBlock(), _createBlock(_unref(Disclosure), {
                    key: 1,
                    as: "div",
                    class: "space-y-4",
                    defaultOpen: true
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(DisclosureButton), {
                        class: _normalizeClass([
                            _unref(currentRoutePath) == item.parentUrl
                            ? 'text-primary-500 pl-0'
                            : 'text-gray-600 hover:text-black pl-8',
                            'group w-full flex items-center py-2 text-left text-sm font-medium focus:outline-none focus:ring-2 focus:ring-gray-300',
                            ])
                      }, {
                        default: _withCtx(() => [
                          (_unref(currentRoutePath) == item.parentUrl)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_11))
                            : _createCommentVNode("", true),
                          _createElementVNode("img", {
                            src: _unref(currentRoutePath) == item.parentUrl ? item.activeIcon : item.icon,
                            class: "flex-shrink-0 w-5 h-5 mr-5"
                          }, null, 8, _hoisted_12),
                          _createElementVNode("span", _hoisted_13, _toDisplayString(item.name), 1)
                        ]),
                        _: 2
                      }, 1032, ["class"]),
                      _createVNode(_unref(DisclosurePanel), { class: "space-y-4" }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.children, (subItem) => {
                            return (_openBlock(), _createElementBlock(_Fragment, {
                              key: subItem.name
                            }, [
                              (subItem.allowed)
                                ? (_openBlock(), _createElementBlock("a", {
                                    key: 0,
                                    href: subItem.href,
                                    class: _normalizeClass([
                                    _unref(currentRoutePath) == subItem.parentUrl
                                    ? 'text-primary-500 pl-0'
                                    : 'text-gray-500 hover:text-black pl-8',
                                    'group flex items-center px-0 py-2 text-sm font-medium rounded-md',
                                ]),
                                    "aria-current": subItem.current ? 'page' : undefined
                                  }, [
                                    (_unref(currentRoutePath) == subItem.parentUrl)
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_15))
                                      : _createCommentVNode("", true),
                                    _createElementVNode("img", {
                                      src: _unref(currentRoutePath) == subItem.parentUrl ? subItem.activeIcon : subItem.icon,
                                      class: _normalizeClass([ 'mr-6 flex-shrink-0 h-5 w-5' ])
                                    }, null, 8, _hoisted_16),
                                    _createTextVNode(" " + _toDisplayString(subItem.name), 1)
                                  ], 10, _hoisted_14))
                                : _createCommentVNode("", true)
                            ], 64))
                          }), 128))
                        ]),
                        _: 2
                      }, 1024)
                    ]),
                    _: 2
                  }, 1024))
                : _createCommentVNode("", true)
          ], 64))
        }), 128))
      ])
    ])
  ]))
}
}

})